export default function (instance) {
  return {
    add_list_photo(p) {
      return instance.post("add_list_photo", {
        foto34_file: p.foto34_file,
      });
    },
    get_document(p) {
      return instance.post(`reg/get_document?page=${p.page}`, {
        id_faculty: p.id_faculty,
        id_direction: p.id_direction,
        id_spes: p.id_spes,
        id_type_o: p.id_type_o,
        id_f_o: p.id_f_o,
        id_tur: p.id_tur,
        per_page: p.perPage,
        status_proverka: p.status_proverka,
        status_prinyat: p.status_prinyat,
        status_print: p.status_print,
        status_avn: p.status_avn,
        searchByFio: p.searchByFio
      });
    },

    chek_document(p) {
      return instance.post("reg/chek_document", {
        id_document: p.id_document,
      });
    },
    export__myedu(p) {
      return instance.post("reg/export__myedu", p);
    },

    add_list(p) {
      return instance.post("reg/add_list", p, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );
    },
  };
}
